exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/navigation-laboratoire/navigation-laboratoire.component.css
// module id = ../../../../../src/app/shared/navigation-laboratoire/navigation-laboratoire.component.css
// module chunks = main